module.exports = {
      id: "fb-blue-usage",
      viewBox: "0 0 28 27.83",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#fb-blue",
      toString: function () {
        return this.url;
      }
    }